import React from 'react';
import { Link } from 'react-router-dom';
import DateBlock from './DateBlock';
import StatusBadge from '../common/StatusBadge';
import { PATHS, toPath } from '../../routes/paths';
import { formatTime } from '../../utils/date';
import { accentFor } from '../../utils/constants';

/** Compact "Coming up" row on Home. */
export default function AppointmentRow({ appointment: a }) {
  return (
    <Link to={toPath(PATHS.appointmentDetail, { id: a.id })} className="card appt-row">
      <DateBlock date={a.date} showMonth={false} size="sm" accent={accentFor(a.doctor?.name)} />
      <div className="u-grow">
        <p className="appt-row__name">{a.doctor?.name}</p>
        <p className="appt-row__meta">
          {`${a.doctor?.specialty} · `}
          <span className="u-nowrap">{formatTime(a.time)}</span>
        </p>
      </div>
      <StatusBadge status={a.status} short />
    </Link>
  );
}
